import { EQueryKeys } from '@enums/queryKeys.enum';

export const queryKeys = {
  agents: {
    all: [EQueryKeys.Agents] as const,
    capabilities: () => [EQueryKeys.Agents, 'capabilities'] as const,
    calls: (id: string) => [EQueryKeys.Agents, 'detail', id, 'calls'] as const,
    configuration: (id: string) =>
      [EQueryKeys.Agents, 'detail', id, 'configuration'] as const,
    detail: (id: string) => [EQueryKeys.Agents, 'detail', id] as const,
    editorData: (id: string) =>
      [EQueryKeys.Agents, 'detail', id, 'editor-data'] as const,
    knowledgeBases: () => [EQueryKeys.Agents, 'knowledge-bases'] as const,
    knowledgeSelection: (id: string) =>
      [EQueryKeys.Agents, 'detail', id, 'knowledge-bases'] as const,
    list: () => [EQueryKeys.Agents, 'list'] as const,
    versions: (id: string) =>
      [EQueryKeys.Agents, 'detail', id, 'versions'] as const,
  },
  calls: {
    all: [EQueryKeys.Calls] as const,
    list: () => [EQueryKeys.Calls, 'list'] as const,
    testOptions: () => [EQueryKeys.Calls, 'test-options'] as const,
  },
  googleSheets: {
    all: [EQueryKeys.GoogleSheets] as const,
    tabs: () => [EQueryKeys.GoogleSheets, 'tabs'] as const,
  },
  sessions: {
    all: [EQueryKeys.Sessions] as const,
    current: () => [EQueryKeys.Sessions, 'current'] as const,
  },
};
